import React from 'react'
import { useTrack } from './track-context'

export const GuidebookLink = ({
  href,
  event: eventText,
}: {
  href: string
  event?: string
}) => {
  const track = useTrack()
  return (
    <>
      [
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          if (eventText) {
            track(eventText, { language: 'JavaScript' })
          }
        }}
      >
        Guidebook
      </a>
      ]
    </>
  )
}
